import React, { useState, useEffect } from 'react';
import api from '../services/api';

function VRGlasses() {
  const [glasses, setGlasses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [totalPages, setTotalPages] = useState(0);
  const [error, setError] = useState(null);

  const fetchGlasses = async (pageNum = 1) => {
    setLoading(true);
    try {
      const response = await api.getVRGlasses(pageNum, 20, null, search);
      setGlasses(response.items || []);
      setTotalPages(response.total_pages || 0);
      setPage(pageNum);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGlasses(1);
  }, [search]);

  const handleDelete = async (recordId) => {
    if (window.confirm('Are you sure?')) {
      try {
        await api.deleteVRGlass(recordId);
        fetchGlasses(page);
      } catch (err) {
        setError(err.message);
      }
    }
  };

  return (
    <div className="content-section">
      <h1>VR Glasses</h1>

      {error && <div className="error-message">{error}</div>}

      <div className="toolbar">
        <input
          type="text"
          placeholder="Search VR glasses..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="search-input"
        />
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <table className="table">
            <thead>
              <tr>
                <th>Record ID</th>
                <th>User</th>
                <th>Note</th>
                <th>Data</th>
                <th>Created</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {glasses.map((glass) => (
                <tr key={glass.id}>
                  <td>{glass.id}</td>
                  <td>{glass.user_full_name || glass.username}</td>
                  <td className="truncate">{glass.note || '-'}</td>
                  <td>{glass.has_raw_data ? '✓' : '-'}</td>
                  <td>{new Date(glass.created_at).toLocaleDateString()}</td>
                  <td>
                    <button
                      className="btn btn-small btn-danger"
                      onClick={() => handleDelete(glass.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="pagination">
            <button
              onClick={() => fetchGlasses(page - 1)}
              disabled={page <= 1}
              className="btn btn-small"
            >
              Previous
            </button>
            <span>Page {page} of {totalPages}</span>
            <button
              onClick={() => fetchGlasses(page + 1)}
              disabled={page >= totalPages}
              className="btn btn-small"
            >
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default VRGlasses;
